"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Widget generic error.
 */
class WidgetError extends Error {
    /**
     * Constructs the error.
     *
     * @param {string} message
     */
    constructor(message) {
        super(message);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, WidgetError.prototype);
        this.name = this.getCode();
    }
    /**
     * Extends previous error with additional message.
     *
     * @param message
     * @param previous
     */
    static extend(message, previous) {
        if (typeof previous === 'object') {
            previous.message = message + ": " + (previous.message ? previous.message : '');
            Object.setPrototypeOf(previous, this.prototype);
        }
        else if (['string', 'number'].indexOf(typeof previous) !== -1) {
            previous = message + ": " + previous;
        }
        return previous;
    }
    /**
     * Get the code name of the error.
     *
     * @return {string}
     */
    static getCode() {
        return this.code;
    }
    /**
     * Checks whether error is instance of this.
     *
     * @param error
     * @return {boolean}
     */
    static is(error) {
        return typeof error.getCode === "function" && this.getCode() === error.getCode();
    }
    /**
     * Catches the error if matching, throws otherwise.
     *
     * @param {*} error
     * @param {Function} callback
     */
    static catch(error, callback) {
        if (this.is(error)) {
            return callback(error);
        }
        else {
            throw error;
        }
    }
    /**
     * Catches the error if matching, throws otherwise for promises.
     *
     * @param {Function} callback
     */
    static and(callback) {
        return (error) => {
            if (this.is(error)) {
                return callback(error);
            }
            else {
                throw error;
            }
        };
    }
    /**
     * Catches the error if not matching, throws otherwise for promises.
     *
     * @param {Function} callback
     */
    static andNot(callback) {
        return (error) => {
            if (!this.is(error)) {
                return callback(error);
            }
            else {
                throw error;
            }
        };
    }
    /**
     * Get the code name of the error.
     *
     * @return {string}
     */
    getCode() {
        return this.constructor.code;
    }
}
/**
 * The name of the error.
 *
 * @type {string}
 */
WidgetError.code = "SW-GENERIC";
exports.default = WidgetError;
